import React, { useState, useEffect } from "react";
import Select from "react-select";
import { userOrder } from '../../states/userOrder';
import { toast } from 'react-toastify';
import { apiGet, apiPost } from '../../utils/api';
import { configShop } from '../../states/configShop';
import { FaMapMarkerAlt, FaCity, FaArrowRight } from "react-icons/fa";

const AddressAdd = ({ setOpenModal }) => {
    const { dataConfig } = configShop();
    const { setDataUser } = userOrder();
    const [address, setAddress] = useState('');
    const [cityId, setCityId] = useState(0);
    const [cityName, setCityName] = useState('');
    const [listaCiudades, setListaCiudades] = useState([]);
    const [loading, setLoading] = useState(false);

    const brandColor = dataConfig?.page_menu?.button?.color      ?? "#6C63FF";
    const brandText  = dataConfig?.page_menu?.button?.color_text ?? "#ffffff";

    const obtenerCiudades = async () => {
        const respuesta = await apiGet('/delivery/list');
        setListaCiudades(respuesta.data);
    };

    useEffect(() => { obtenerCiudades(); }, []);

    const guardarInfo = async () => {
        if (cityId === 0) {
            toast.error(dataConfig.delivery_mode === 4 ? "Seleccione un barrio" : "Seleccione una ciudad", {
                position: "top-center", autoClose: 4000,
            });
            return;
        }
        if (!address.trim()) {
            toast.error("Ingrese la dirección de entrega", { position: "top-center", autoClose: 4000 });
            return;
        }

        setLoading(true);
        try {
            if (dataConfig.delivery_mode == 4) {
                setDataUser({ address, city: cityId, city_name: cityName, popAddress: false, uuidShop: 'FFFFF', deliveryMethod: 1 });
                setOpenModal(false);
            } else {
                const respuestaJSON = await apiPost('/search/address', { city_id: cityId, address });
                if (respuestaJSON.message !== "success") {
                    toast.error(respuestaJSON.message, { position: "top-center", autoClose: 5000 });
                } else {
                    setDataUser({ address, city: cityId, city_name: cityName, popAddress: false, uuidShop: respuestaJSON.data.id_branchs, deliveryMethod: 1 });
                    setOpenModal(false);
                }
            }
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    const selectStyles = {
        container: (p) => ({ ...p, width: "100%" }),
        control: (p, state) => ({
            ...p,
            minHeight: "52px",
            borderRadius: "14px",
            border: state.isFocused ? `2px solid ${brandColor || '#6C63FF'}` : "2px solid #EBEBF0",
            background: "#F7F7FA",
            boxShadow: "none",
            paddingLeft: "36px",
            fontSize: "15px",
            "&:hover": { borderColor: brandColor || '#6C63FF' },
        }),
        valueContainer: (p) => ({ ...p, paddingLeft: "4px" }),
        placeholder: (p) => ({ ...p, color: "#AAAAB5" }),
        singleValue: (p) => ({ ...p, color: "#1A1A2E" }),
        menu: (p) => ({ ...p, borderRadius: "12px", boxShadow: "0 8px 24px rgba(0,0,0,0.12)", zIndex: 1200 }),
        option: (p, state) => ({
            ...p,
            background: state.isSelected ? (brandColor || '#6C63FF') : state.isFocused ? "#F0EFFE" : "white",
            color: state.isSelected ? "#fff" : "#1A1A2E",
            borderRadius: "8px",
            margin: "2px 4px",
            width: "calc(100% - 8px)",
        }),
        indicatorSeparator: () => ({ display: "none" }),
    };

    const isBarrio = dataConfig.delivery_mode === 4;

    return (
        <div style={{ padding: "20px", display: "flex", flexDirection: "column", gap: "16px" }}>

            {/* Descripción */}
            <div style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                background: `${brandColor}12`,
                borderRadius: "14px",
                padding: "14px",
            }}>
                <FaMapMarkerAlt size={20} color={brandColor || "#6C63FF"} />
                <span style={{ fontSize: "13px", color: "#5C5C7A", lineHeight: 1.4 }}>
                    Ingresa tu {isBarrio ? "barrio" : "ciudad"} y dirección exacta para calcular el domicilio.
                </span>
            </div>

            {/* Ciudad / Barrio */}
            <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                <label style={{ fontSize: "13px", fontWeight: "600", color: "#5C5C7A", paddingLeft: "4px" }}>
                    {isBarrio ? "Barrio" : "Ciudad"}
                </label>
                <div style={{ position: "relative" }}>
                    <FaCity style={{
                        position: "absolute", left: "14px", top: "50%", transform: "translateY(-50%)",
                        color: "#AAAAB5", fontSize: "15px", zIndex: 1, pointerEvents: "none",
                    }} />
                    <Select
                        defaultValue={{ label: isBarrio ? "Seleccione un barrio" : "Seleccione una ciudad", value: 0 }}
                        options={listaCiudades.map((c) => ({ label: c.name, value: `${c.id}` }))}
                        styles={selectStyles}
                        onChange={(e) => { setCityId(e.value); setCityName(e.label); }}
                        theme={(t) => ({ ...t, borderRadius: 14 })}
                        placeholder={isBarrio ? "Seleccione un barrio" : "Seleccione una ciudad"}
                    />
                </div>
            </div>

            {/* Dirección */}
            <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                <label style={{ fontSize: "13px", fontWeight: "600", color: "#5C5C7A", paddingLeft: "4px" }}>
                    Dirección de entrega
                </label>
                <div style={{ position: "relative" }}>
                    <FaMapMarkerAlt style={{
                        position: "absolute", left: "14px", top: "50%", transform: "translateY(-50%)",
                        color: "#AAAAB5", fontSize: "15px", zIndex: 1, pointerEvents: "none",
                    }} />
                    <input
                        type="text"
                        placeholder="Ej: Calle 45 # 12-34, Apto 301"
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                        style={{
                            width: "100%",
                            height: "52px",
                            paddingLeft: "42px",
                            paddingRight: "14px",
                            borderRadius: "14px",
                            border: "2px solid #EBEBF0",
                            background: "#F7F7FA",
                            fontSize: "15px",
                            color: "#1A1A2E",
                            outline: "none",
                            boxSizing: "border-box",
                            transition: "border-color 0.18s",
                        }}
                        onFocus={(e) => { e.target.style.borderColor = brandColor || '#6C63FF'; e.target.style.background = '#FFF'; }}
                        onBlur={(e) => { e.target.style.borderColor = '#EBEBF0'; e.target.style.background = '#F7F7FA'; }}
                    />
                </div>
            </div>

            {/* Botón */}
            <button
                onClick={guardarInfo}
                disabled={loading}
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "10px",
                    width: "100%",
                    height: "52px",
                    border: "none",
                    borderRadius: "14px",
                    background: brandColor || "#6C63FF",
                    color: brandText || "#FFFFFF",
                    fontSize: "16px",
                    fontWeight: "700",
                    cursor: loading ? "not-allowed" : "pointer",
                    opacity: loading ? 0.7 : 1,
                    boxShadow: `0 4px 16px ${brandColor ? brandColor + "55" : "rgba(108,99,255,0.3)"}`,
                    transition: "opacity 0.15s, transform 0.12s",
                    marginTop: "4px",
                }}
            >
                {loading ? (
                    <span className="rg-btn-spinner" />
                ) : (
                    <>
                        <span>Guardar dirección</span>
                        <FaArrowRight size={14} />
                    </>
                )}
            </button>
        </div>
    );
};

export default AddressAdd;
